module.exports = __webpack_public_path__ + "img/costEffective.45e7c3c7.jpg";